import { useMemo } from 'react';

/**
 * Determines if the claim window has ended (both claim and pre-claim are disabled)
 */
export const useIsClaimEnded = (): boolean => {
  return useMemo(
    () =>
      process.env.NEXT_PUBLIC_APP_CLAIM_CLAIM_ENABLED !== 'true' &&
      process.env.NEXT_PUBLIC_PRE_CLAIM_ACTIVE !== 'true',
    [],
  );
};
